import { report_operational_vehicleService } from '../_services';

const state = { onRequest: false, report_operational_vehicle: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        report_operational_vehicleService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  report_operational_vehicle: state => {
    return state.report_operational_vehicle
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.report_operational_vehicle = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.report_operational_vehicle = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.report_operational_vehicle = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const report_operational_vehicles = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
